export default "__VITE_ASSET__C45n$TCP__"